import type { FavoriteViewFolderList } from '@/api/favorites'

export const mockFavoriteViewFolders: FavoriteViewFolderList = {
  items: [
    {
      id: '0002',
      name: 'Shoes',
      emoji: '1f45f',
      viewCount: 8,
    },
    {
      id: '0003',
      name: 'Badminton families',
      emoji: '1f3f8',
      viewCount: 1,
    },
    {
      id: '0004',
      name: 'Fishing',
      emoji: '1f3a3',
      viewCount: 1,
    },
  ],
}